import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { BookOpen, Utensils, Activity, ChefHat } from 'lucide-react';
export function ContentSection() {
  const recipes = ['Ensalada mediterránea con garbanzos', 'Sopa de lentejas con verduras', 'Salmón al limón con papas', 'Crema de calabaza y jengibre', 'Tostadas de aguacate con huevo', 'Hummus casero con crudités', 'Bol de quinoa con verduras asadas'];
  return <Section background="white" className="overflow-hidden" data-id="element-70">
      <div className="text-center mb-10 md:mb-16" data-id="element-71">
        <h2 className="text-2xl md:text-4xl font-bold text-[#2D6A4F]" data-id="element-72">
          Qué incluye exactamente
        </h2>
        <p className="mt-2 md:mt-4 text-gray-600" data-id="element-73">
          Todo lo que necesitas para empezar hoy mismo
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-20 items-center" data-id="element-74">
        {/* Left Column: Content Details */}
        <div className="space-y-7 md:space-y-10" data-id="element-75">
          {/* Part 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex gap-4" data-id="element-76">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#FEFAE0] flex items-center justify-center text-[#BC6C25]" data-id="element-77">
              <BookOpen className="w-6 h-6" data-id="element-78" />
            </div>
            <div data-id="element-79">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-80">
                1. Entendiendo la diabetes y prevención
              </h3>
              <p className="text-gray-600" data-id="element-81">
                Tipos (1 y 2), prediabetes, síntomas y señales importantes para
                que entiendas tu cuerpo.
              </p>
            </div>
          </motion.div>

          {/* Part 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex gap-4" data-id="element-82">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#FEFAE0] flex items-center justify-center text-[#BC6C25]" data-id="element-83">
              <Activity className="w-6 h-6" data-id="element-84" />
            </div>
            <div data-id="element-85">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-86">
                2. Cambios efectivos
              </h3>
              <p className="text-gray-600" data-id="element-87">
                Nutrición consciente, movimiento, bienestar integral + guía de
                ejercicio práctica.
              </p>
              <ul className="mt-2 space-y-1 text-sm text-gray-500 pl-4 border-l-2 border-[#52B788]" data-id="element-88">
                <li data-id="element-89">• Alimentos prioritarios (fibra, proteínas, grasas)</li>
                <li data-id="element-90">• Métodos de cocción recomendados</li>
                <li data-id="element-91">• Porciones tipo "plato dividido"</li>
                <li data-id="element-92">• Monitoreo básico (A1C, presión, lípidos)</li>
              </ul>
            </div>
          </motion.div>

          {/* Part 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex gap-4" data-id="element-93">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#FEFAE0] flex items-center justify-center text-[#BC6C25]" data-id="element-94">
              <Utensils className="w-6 h-6" data-id="element-95" />
            </div>
            <div data-id="element-96">
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-97">
                3. 30 recetas para el día a día
              </h3>
              <p className="text-gray-600 mb-3" data-id="element-98">
                Opciones prácticas para mantener una alimentación más estable
                sin aburrirte.
              </p>

              <div className="bg-[#FEFAE0] p-4 md:p-5 rounded-xl" data-id="element-99">
                <h4 className="font-semibold text-[#2D6A4F] mb-2 flex items-center" data-id="element-100">
                  <ChefHat className="w-4 h-4 mr-2" data-id="element-101" />
                  Muestra del menú:
                </h4>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2" data-id="element-102">
                  {recipes.map((recipe, i) => <li key={i} className="text-sm text-gray-700 flex items-center" data-id="element-103">
                      <span className="w-1.5 h-1.5 bg-[#BC6C25] rounded-full mr-2" data-id="element-104"></span>
                      {recipe}
                    </li>)}
                </ul>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Right Column: Image */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative h-full min-h-[300px] md:min-h-[400px] rounded-2xl overflow-hidden shadow-2xl" data-id="element-105">
          <img src="https://cdn.magicpatterns.com/uploads/6e9jkW9TDqxXBYF8fyfX5d/diabetes_foto2.png" alt="Plato saludable y equilibrado" className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-106" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent flex items-end p-5 md:p-8" data-id="element-107">
            <p className="text-white font-medium text-lg" data-id="element-108">
              Comer bien no significa comer aburrido.
            </p>
          </div>
        </motion.div>
      </div>
    </Section>;
}